import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/Layout'
import Callback from '@/components/Callback'
import Community from '@/components/Community'
import CreateCommunity from '@/components/CreateCommunity'
import Inbox from '@/components/Inbox'
import IncompleteRequestList from '@/components/IncompleteRequestList'
import Members from '@/components/Members'
import MemberProfile from '@/components/MemberProfile'
import Template from '@/components/Template'
import SmsTemplate from '@/components/SmsTemplate';
import ThankYou from '@/components/ThankYou'
import AddFeedback from '@/components/AddFeedback'
import FeedbackView from '@/components/FeedbackView'
import Interact from '@/components/Interact'
import GeminiTrainer from '@/components/gemini/AITrainer'
import GeminiMatches from '@/components/gemini/Matches'
import InteractAddGive from '@/components/InteractAddGive'
import InteractRequestFeedback from '@/components/InteractRequestFeedback'
import InteractSendEmail from '@/components/InteractSendEmail'
import InteractSendConnectEmail from '@/components/InteractSendConnectEmail'
import InteractMatch from '@/components/InteractMatch'
import InteractEdit from '@/components/InteractEdit'
import InteractTag from '@/components/InteractTag'
import Login from '@/components/Login'
import Register from '@/components/Register'
import EmailRequest from '@/components/EmailRequest'
import CreateTemplate from '@/components/CreateTemplate'
import CreateSmsTemplate from '@/components/CreateSmsTemplate'
import RequestDetail from '@/components/RequestDetail'
import IncompleteRequestDetail from '@/components/IncompleteRequestDetail'
import RecruitingList from '@/components/RecruitingList'
import RecruitingDetail from '@/components/RecruitingDetail'
import RecruitingMatch from '@/components/RecruitingMatch'
import NewResponses from '@/components/NewResponses'
import RequestStatus from '@/components/RequestStatus'
import CommunityChatbotRequestPage from '@/components/CommunityChatbotRequestPage'
import CommunityRequestPage from '@/components/CommunityRequestPage'
import CommunityRequestPageV2 from '@/components/CommunityRequestPageV2'
import CommunityRequestPageV1Short from '@/components/CommunityRequestPageV1Short'
import ConfigureOutlook from '@/components/ConfigureOutlook'
import MemberUnsubscribe from '@/components/MemberUnsubscribe'
import UpdateRequestStatus from '@/components/UpdateRequestStatus'
import ResponseStatus from '@/components/ResponseStatus'
import Configuration from '@/components/Configuration'
import ConfigurationEdit from '@/components/ConfigurationEdit'
import ConfigurationAdd from '@/components/ConfigurationAdd'
import ConfigurationProtopiaOwnerAdd from '@/components/ConfigurationProtopiaOwnerAdd'
import ConfigurationWizardContentAdd from '@/components/ConfigurationWizardContentAdd'
// import CommunityConfiguration from '@/components/CommunityConfiguration'
import Communication from '@/components/Communication'
import UpdateMemberProfileChange from '@/components/UpdateMemberProfileChange'
import Setting from '@/components/Settings'
import RequestResponse from '@/components/RequestResponse'
import ResponseFollowUp from '@/components/ResponseFollowUp'
import ShareRequest from '@/components/ShareRequest'
import RequestClose from '@/components/RequestClose'
import RequestSnooze from '@/components/requestSnooze'
import RequestEscalate from '@/components/RequestEscalate'
import PendingResponses from '@/components/PendingResponses'
import NotFound from '../components/NotFound.vue'
Vue.use(Router)

export default new Router({


	mode: 'history',
	linkExactActiveClass: 'is-active',
	routes: [{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			title: 'Protopia Login'
		}
	}, {
		path: '/thank-you',
		component: ThankYou,
		meta: {
			title: 'Thank You'
		}
	}, {
		path: '/callback',
		name: 'Callback',
		component: Callback
	}, {
		path: '/register',
		name: 'Register',
		component: Register,
		meta: {
			title: 'Protopia Signup'
		}
	}, {
		path: '/',
		component: Layout,
		children: [{
			path: '/',
			alias: '/home',
			component: Inbox,
			props: {
				view: 'all'
			},
			meta: {
				requiresAuth: true,
				title: 'Home'
			}
		}, {
			path: 'templates/create',
			props: true,
			component: CreateTemplate,
			meta: {
				requiresAuth: true,
				title: 'Create Template'
			}
		}, {
			path: 'templates/:template_id',
			props: true,
			component: Template,
			meta: {
				requiresAuth: true,
				title: 'Edit Template'
			}
		}, {
			path: 'templates/sms/create',
			props: true,
			component: CreateSmsTemplate,
			meta: {
				requiresAuth: true,
				title: 'Create SMS Template'
			}
		}, {
			path: 'templates/sms/:template_id',
			props: true,
			component: SmsTemplate,
			meta: {
				requiresAuth: true,
				title: 'Edit Template'
			}
		}, {
			path: 'communities/create',
			props: true,
			component: CreateCommunity,
			meta: {
				requiresAuth: true,
				title: 'Create Community'
			}
		}, {
			path: 'communities/:community_id',
			props: true,
			component: Community,
			meta: {
				requiresAuth: true,
				title: 'Communities'
			}
		}, {
			path: 'members',
			component: Members,
			props: {
				view: ''
			},
			meta: {
				requiresAuth: true,
				title: 'Member'
			}
		}, {
			path: 'members/all',
			component: Members,
			props: {
				view: ''
			},
			meta: {
				requiresAuth: true,
				title: 'All Members'
			}
		}, {
			path: 'members/search',
			component: Members,
			props: (route) => ({
				view: 'search?term=' + route.query.term
			}),
			meta: {
				requiresAuth: true,
				title: 'Member search'
			}
		}, {
			path: 'members/:member_id',
			props: true,
			component: MemberProfile,
			meta: {
				requiresAuth: true,
				title: 'Member Profile'
			}
		}, {
			path: 'asks',
			component: Inbox,
			props: {
				view: 'all'
			},
			meta: {
				requiresAuth: true,
				title: 'Asks'
			}
		}, {
			path: 'asks/all',
			component: Inbox,
			props: {
				view: 'all'
			},
			meta: {
				requiresAuth: true,
				title: 'All Asks'
			}
		}, {
			path: 'asks/search',
			component: Inbox,
			props: (route) => ({
				view: 'search?term=' + route.query.term
			}),
			meta: {
				requiresAuth: true,
				title: 'Search Asks'
			}
		}, {
			path: 'asks/responses',
			component: NewResponses,
			meta: {
				requiresAuth: true,
				title: 'New Responses'
			}
		},
		{
			path: 'asks/pending-responses',
			component: PendingResponses,
			meta: {
				requiresAuth: true,
				title: 'Pending Responses'
			}
		}, {
			path: 'asks/incomplete-request',
			component: IncompleteRequestList,
			props: {
				view: ''
			},
			meta: {
				requiresAuth: true,
				title: 'Incomplete Request'
			}
		}, {
			path: 'incomplete-asks/:ask_id/request',
			component: IncompleteRequestDetail,
			meta: {
				requiresAuth: true,
				title: 'Incomplete Request Detail'
			}
		}, {
			path: 'recruiting',
			component: RecruitingList,
			meta: {
				requiresAuth: true,
				title: 'Recruiting'
			}
		}, {
			path: 'recruiting/:opportunity_id',
			component: RecruitingDetail,
			meta: {
				requiresAuth: true,
				title: 'Opportunity Detail'
			}
		}, {
			path: 'recruiting-match/:opportunity_id',
			component: RecruitingMatch,
			meta: {
				requiresAuth: true,
				title: 'Opportunity Matching'
			}
		}, {
			path: 'asks/:ask_id/request',
			component: RequestDetail,
			meta: {
				requiresAuth: true,
				title: 'Request Detail'
			}
		}, {
			path: 'asks/:ask_id/edit',
			component: InteractEdit,
			meta: {
				requiresAuth: true,
				title: 'Edit Ask'
			}
		}, {
			path: 'asks/:ask_id/respond',
			component: InteractAddGive,
			meta: {
				requiresAuth: true,
				title: 'Respond'
			}
		}, {
			path: 'gemini',
			component: GeminiTrainer,
			meta: {
				requiresAuth: true,
				title: 'Gemini AI Trainer'
			}
		}, {
			path: 'gemini/:ask_id',
			component: GeminiTrainer,
			meta: {
				requiresAuth: true,
				title: 'Gemini AI Trainer'
			}
		}, {
			path: 'gemini-match/:ask_id',
			component: GeminiMatches,
			meta: {
				requiresAuth: true,
				title: 'Gemini Connections'
			}
		}, {
			path: 'asks/:ask_id/send-request',
			component: InteractSendEmail,
			props: { template: 'first_email', action: 'send-request' },
			meta: {
				requiresAuth: true,
				title: 'Send First Email'
			}
		}, {
			path: 'asks/:ask_id/send-reminder-email',
			component: InteractSendEmail,
			props: { template: 'reminder', action: 'send-reminder-email' },
			meta: {
				requiresAuth: true,
				title: 'Reminder Email'
			}
		}, {
			path: 'asks/:ask_id/send-connect-email',
			component: InteractSendConnectEmail,
			props: { template: 'email_connect' },
			meta: {
				requiresAuth: true,
				title: 'Connect Email'
			}
		}, {
			path: 'asks/:ask_id/send-response',
			component: InteractSendConnectEmail,
			props: { template: 'email_connect' },
			meta: {
				requiresAuth: true,
				title: 'Send Response'
			}
		}, {
			path: 'asks/:ask_id/get-feedback',
			component: InteractRequestFeedback,
			props: { template: 'email_feedback', action: 'request-feedback' },
			meta: {
				requiresAuth: true,
				title: 'Request Feedback'
				}
			},
		 {
			path: 'asks/:ask_id/send-join-email',
			component: InteractSendEmail,
			props: { template: 'join' },
			meta: {
				requiresAuth: true,
				title: 'Send Join Email'
			}
		}, {
			path: 'asks/:ask_id/match',
			component: InteractMatch,
			meta: {
				requiresAuth: true,
				title: 'Match Advisors'
			}
		}, {
			path: 'asks/:ask_id/tag',
			component: InteractTag,
			meta: {
				requiresAuth: true,
				title: 'Tags'
			}
		}, {
			path: 'asks/:ask_id/:action',
			component: Interact,
			meta: {
				requiresAuth: true,
				title: 'Actions'
			}
		}, {
			path: '/configuration/reference-:reference',
			component: Configuration,
			meta: {
			  requiresAuth: true,
			  title: 'Reference - Configuration'
			}
		}, {
		  	path: '/configuration/reference-:reference/:editId/edit',
		  	component: ConfigurationEdit,
		  	meta: {
				requiresAuth: true,
		    	title: 'Reference - Configuration'
		  	}
	  	}, {
			path: '/configuration/filter-words/add',
			component: ConfigurationAdd,
			meta: {
			  requiresAuth: true,
			  title: 'Fillter Word'
			}
		}, {
			path: '/configuration/protopia-owner/add',
			component: ConfigurationProtopiaOwnerAdd,
			meta: {
			  requiresAuth: true,
			  title: 'Protopia Owner'
			}
		}, {
			path: '/configuration/wizard-content/add',
			component: ConfigurationWizardContentAdd,
			meta: {
			  requiresAuth: true,
			  title: 'Wizard Content'
			}
		}, {
    		path: '/configuration/settings',
    		component: Setting,
    		meta: {
  			requiresAuth: true,
      			title: 'General configuration settings'
    		}
	  	}],
		meta: {
			requiresAuth: true
		}
	}, {
		path: '/request-help',
		name: 'EmailRequest',
		component: EmailRequest,
		meta: {
			title: 'Accept or Decline a Request'
		},
		props: (route) => ({
			communityId: route.query.communityId,
			memberid: route.query.memberid,
			askid: route.query.askid,
			action: route.query.helpaction,
			skip: route.query.skip || 'no'
		})
	},
	{
		path: '/request-snooze',
		name: 'requestSnooze',
		component: RequestSnooze,
		meta: {
			title: 'Snooze Request'
		},
		props: (route) => ({
			memberid: route.query.memberid,
			askid: route.query.askid
		})
	},
	{
		path: '/request-share',
		name: 'ShareRequest',
		component: ShareRequest,
		meta: {
			title: 'Share Request'
		},
		props: (route) => ({
			communityId: route.query.communityId,
			memberid: route.query.memberid,
			askid: route.query.askid,
			action: route.query.helpaction,
			helpaction: 'no',
			share: 'share'
		})
	}, {
			path: '/feedback/',
			name: 'FeedbackView',
			component: FeedbackView,
			props: (route) => ({
				context: route.query.context,
				askId: route.query.askId
			}),
			meta: {
				title: 'Provide Feedback'
			}

		},
		{
		path: '/add-feedback',
		name: 'AddFeedback',
		component: AddFeedback,
		meta: {
			title: 'Share Your Feedback'
		},
		props: (route) => ({
			communityId: route.query.communityId,
			askID: route.query.askid,
			giveID: route.query.giveid,
			num: route.query.num,
			feedback: route.query.feedback
		})
	}, {
	  path: '/check-status',
	  name: 'RequestStatus',
	  component: RequestStatus,
	  meta: {
	    title: 'Initializing Request Status'
	  },
	  props: (route) => ({
	    communityId: route.query.communityId,
	    ask_id: route.query.askid,
	    action: route.query.action,
	    status: route.query.status,
	    adminId: route.query.adminId
	  })
	}, {
	  path: '/check-response-status',
	  name: 'ResponseStatus',
	  component: ResponseStatus,
	  meta: {
	    title: 'Initializing Response Status'
	  },
	  props: (route) => ({
	    ask_id: route.query.askid,
	    action: route.query.action,
	    status: route.query.status,
	    adminId: route.query.adminId,
	    giveId: route.query.giveId
	  })
	}, {
		// Chatbot Request page
		path: '/chatbot/:community_id',
		props: true,
		component: CommunityChatbotRequestPage,
		meta: {
		  title: 'Get Help'
		}
	}, {
		// Chatbot Request page
		path: '/chatbot/:community_id/:sourceparam',
		props: true,
		component: CommunityChatbotRequestPage,
		meta: {
		  title: 'Get Help'
		}
	}, {
	  //as per new design for post new request
	  path: '/community-request/:community_id',
	  props: true,
	  component: CommunityRequestPageV1Short,
	  meta: {
	    title: 'Get Help'
	  }
	}, {
		// new request v2 form
		path: '/community-request-v2/:community_id/:sourceparam',
	  props: true,
	  component: CommunityRequestPageV2,
	  meta: {
	    title: 'Get Help'
	  }
	}, {
		// new request form
		path: '/community-request/:community_id/:sourceparam',
	  props: true,
	  component: CommunityRequestPageV1Short,
	  meta: {
	    title: 'Get Help'
	  }
	}, {
	  // new request v2 form
	  path: '/community-request-v2/:community_id',
	  props: true,
	  component: CommunityRequestPageV2,
	  meta: {
			title: 'Get Help'
		}
	},
	{
		// new request v3
		path: '/community-request-v3/:community_id',
		props: true,
		component: CommunityRequestPage,
		meta: {
			title: 'Get Help'
		  }
	},
	{
		// new request v3
		path: '/community-request-v3/:community_id/:sourceparam',
		props: true,
		component: CommunityRequestPage,
		meta: {
			title: 'Get Help'
		  }
	},
	{
		path: '/outlook',
		name: 'ConfigureOutlook',
		component: ConfigureOutlook,
		meta: {
			title: 'Initializing Outlook'
		},
		props: (route) => ({
			community_id: route.query.community_id,
			code: route.query.code
		})
	}, {
		path: '/unsubscribe/:community_code',
		name: 'MemberUnsubscribe',
		component: MemberUnsubscribe,
		meta: {
			title: 'Unsubscribe Member Page'
		}
	}, {
	  path: '/update-request-status',
	  name: 'UpdateRequestStatus',
	  component: UpdateRequestStatus,
	  meta: {
	    title: 'Update Request Status'
	  },
	  props: (route) => ({
	    communityId: route.query.communityId,
	    askid: route.query.askid,
	    status: route.query.status,
		type: route.query.type
	  })
	}, {
		path: '/update-response-status',
		name: 'UpdateResponseStatus',
		component: UpdateRequestStatus,
		meta: {
		  title: 'Update Response Status'
		},
		props: (route) => ({
      communityId: route.query.communityId,
		  askid: route.query.askid,
		  status: route.query.status,
		  type: route.query.type
		})
	}, {
		path: '/communication',
		name: 'Communication',
		component: Communication,
		meta: {
		  title: 'Share Advice'
	  	},
		props: (route) => ({
			askid: route.query.askid
		})
	}, {
	  path: '/update-member-profile-changes',
	  name: 'UpdateMemberProfileChange',
	  component: UpdateMemberProfileChange,
	  meta: {
	    title: 'Initializing Update Member profile Changes'
	  },
	  props: (route) => ({
	    changeId: route.query.changeId,
	    action: route.query.action
	  })
  	}, {
		path: '/request-response',
		name: 'Request Response',
		component: RequestResponse,
		meta: {
			title: 'Thank You'
		},
		props: (route) => ({
			communityId: route.query.communityId,
			askId: route.query.askId,
			giveId: route.query.giveId
		})
	}, {
		path: '/response-follow-up',
		name: 'Response Follow-up',
		component: ResponseFollowUp,
		meta: {
			title: 'Response Follow-up'
		},
		props: (route) => ({
			askid: route.query.askid,
			giveid: route.query.giveid,
			helpaction: route.query.helpaction
		})
	}, {
		path: '/request-close',
		name: 'Request Close',
		component: RequestClose,
		meta: {
		  title: 'Request Close'
		},
		props: (route) => ({
		  askid: route.query.askid
		})
	}, {
		path: '/super-user-request-escalate',
		name: 'Request Escalate',
		component: RequestEscalate,
		meta: {
			title: 'Request Escalate'
		},
		props: (route) => ({
			askid: route.query.askid
		})
	},
	// community-scoped fallback for quick connect (for bad sourceparam, etc)
	{
		path: '/community-request/:community_id/:pathMatch(.*)*',
		name: 'CommunityNotFound',
		component: NotFound,
		props: route => ({ community_id: route.params.community_id })
	},
	// community-scoped fallback for long form (for bad sourceparam, etc)
	{
		path: '/community-request-v3/:community_id/:pathMatch(.*)*',
		name: 'CommunityNotFound',
		component: NotFound,
		props: route => ({ community_id: route.params.community_id })
	},
	{
		path: '*',
		name: 'NotFound',
		component: NotFound,
		meta: { title: 'Page Not Found' }
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js